interface Container {
    [name: string]: any;
}

interface Dictionary<T> {
    [key: string]: T;
}

function useif<T = any>(
    value: any,
    useIfNotEmpty: T = null): T {
    return value ?
        useIfNotEmpty :
        null;
}

function useif2<T = any>(
    value: any,
    useIfNotEmpty: () => T = null): T {
    return value ?
        useIfNotEmpty() :
        null;
}


function toDictionary<T, VT>(items: Array<T>, key: (i: T) => string, value: (i: T) => VT): Dictionary<VT> {

    const result: Dictionary<VT> = {};
    for (let i of items) {
        result[key(i)] = value(i);
    }
    return result;
}

function hasFlag<T extends number>(state: T, stateFlag: T) {
    return (state & stateFlag) !== 0;
}

function asDate(value: any): Date | null {

    if (typeof (value) === 'number') {
        return isNaN(value as number) ? null : new Date(value);
    } else if (typeof (value) === 'string') {
        return value ? new Date(value.slice(0, 19) + "Z") : null;
    } else {
        return value as Date;
    }
}

function formatDate(date: Date) {
    return date.getDate() + ". " + (date.getMonth() + 1) + ". " + date.getFullYear();
}

export {
    asDate,
    Container,
    Dictionary,
    formatDate,
    hasFlag,
    toDictionary,
    useif,
    useif2
}